<template>
    <v-dialog
            persistent
            v-model="show"
            width="500"
    >
        <v-card>
            <v-card-title
                    class="headline white grey--text"
                    primary-title
            >
                {{$t('components.confirm_measure_complete.title')}}
            </v-card-title>

            <v-card-text class="white grey--text">
                {{$t('components.confirm_measure_complete.message')}}
            </v-card-text>

            <v-divider class="grey lighten-4"></v-divider>

            <v-card-actions class="white grey--text">
                <v-spacer></v-spacer>
                <v-btn
                        color="secondary"
                        text
                        @click="cancel()"
                >
                    {{$t('general.back')}}
                </v-btn>
                <v-btn
                        color="primary"
                        text
                        @click="confirm()"
                >
                    {{$t('general.continue')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "ConfirmMeasureComplete",
        props: {
            show : {
                type: Boolean,
                default: false
            }
        },
        methods:{
            confirm(){
                this.$emit('confirm');
            },
            cancel(){
                this.$emit('cancel');
            }
        }
    }
</script>

<style scoped>

</style>